var ModalFormController = function($modal) {
    this.$modal = $modal;
    this.$form = $modal.find('.modal-form');
    this.$closeButton = $modal.find('#modal-close-button'); // no needed here i think
    this.$closeCross = $modal.find('#modal-close-cross'); // no needed here i think
}


ModalFormController.prototype.displayErrors = function(errors) {

    var insertError = function(field_name, error_message, $modal) {
        var $field = $modal.find("[name=" + field_name + "]"),
            error = '<div class="text-danger small">' + error_message + '</div>';

        $field.after(error);

    }

    // first clean all previous errors
    this.cleanErrors();

    var $modal = this.$modal;

    for (var key in errors) {
        if (errors.hasOwnProperty(key)) {
            var obj = errors[key];
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    //alert(key + " : " + prop + " = " + obj[prop]);
                    insertError(key, obj[prop], $modal);
                }
            }
        }
    }

}

ModalFormController.prototype.loadData = function(model, fields) {

    var insertValue = function(field_name, value, $modal) {
        var $field = $modal.find("[name=" + field_name + "]");

        //console.log($field);
        //console.log($field.length);
        //
        //if($field.length > 0){
            $field.val(value);
        //} else{
        //    $field = $modal.find(".js-viewing-edit-" + field_name + "");
        //    $field.html(value);
        //    console.log('other field');
        //    console.log($field);
        //}

    }

    // first clean all previous errors
    this.cleanErrors();

    var $modal = this.$modal,
        $copyNextWeekLink = $modal.find('.js-copy-id'),
        $copyNextWeekLinkUrl = $copyNextWeekLink.attr('href');

    //console.log($copyNextWeekLink);

    if($copyNextWeekLink.length > 0){
        $copyNextWeekLink.attr('href', $copyNextWeekLinkUrl.replace(/[0-9]+/g, model.id));
    }

    for (var key in model) {

        //console.log(model[key]);

        if(fields && fields.indexOf(key) >= 0){
            insertValue(key, model[key], $modal);
        }

    }

}

ModalFormController.prototype.loadInspectionData = function(data, fields) {

	var $modal = this.$modal,
		model = data.inspection,
		types = JSON.parse(data.types);

	var insertValue = function(field_name, value, $modal) {
		var $field = $modal.find("[name=" + field_name + "]");

		$field.val(value);

	}

	var typesSelect = $modal.find('.field-type');
	var htmlEmptyTypeOption = '<option selected="selected" value="">--- Select type ---</option>';

	if(types){
		var listItems = htmlEmptyTypeOption,
				typeId = model.type_id;

		$.each(types, function(key, value) {

			if(typeId == value.id){
				listItems += "<option value='"+value.id+"' selected=selected>"+value.name+"</option>";
			} else{
				listItems += "<option value='"+value.id+"'>"+value.name+"</option>";
			}

		});

		typesSelect.html(listItems);
	}

	// first clean all previous errors
	this.cleanErrors();

	for (var key in model) {

		//console.log(model[key]);

		if(fields && fields.indexOf(key) >= 0){
			insertValue(key, model[key], $modal);
		}

	}

}

ModalFormController.prototype.loadTicketData = function(data, fieldsInput, fieldsText) {

	var model = data.ticket,
		contractors = JSON.parse(data.contractors),
		contacts = JSON.parse(data.contacts);

	var insertValueAsText = function(field_name, value, $modal) {
		var $field = $modal.find("[name=" + field_name + "]");
		$field.html(value);
	}

	var insertValue = function(field_name, value, $modal) {
		var $field = $modal.find("[name=" + field_name + "]");
		$field.val(value);
	}

	var contractorsSelect = $('#contractor');
	var contractorContactsSelect = $('#contractor-contact');
	var htmlEmptyContractorOption = '<option selected="selected" value="">--- Select contractor ---</option>';
	var htmlEmptyContractorContactOption = '<option selected="selected" value="">--- Select contractor contact ---</option>';

	if(contractors){
		var listItems = htmlEmptyContractorOption,
		contractorId = model.contractor_id;

		$.each(contractors, function(key, value) {

			if(contractorId == value.id){
				listItems += "<option value='"+value.id+"' selected=selected>"+value.name+"</option>";
			} else{
				listItems += "<option value='"+value.id+"'>"+value.name+"</option>";
			}

		});

		contractorsSelect.html(listItems);
	}

	if(contacts){
		var listItems = htmlEmptyContractorContactOption,
			contactId = model.contractor_contact_id;

		$.each(contacts, function(key, value) {

			if(contactId == value.id){
				listItems += "<option value='"+value.id+"' selected=selected>"+value.name+"</option>";
			} else{
				listItems += "<option value='"+value.id+"'>"+value.name+"</option>";
			}

		});

		contractorContactsSelect.html(listItems);
	}


	// first clean all previous errors
	this.cleanErrors();

	var $modal = this.$modal,
		$links = $modal.find('.js-set-id');

	$links.each(function() {
		var $this = $(this),
            linkUrl = $this.attr('href');

		if($this.length > 0){

			$this.data('ticket', model.id)

			if(linkUrl){
				$this.attr('href', linkUrl.replace(/[0-9]+/g, model.id));
			}

		}
	});

	for (var key in model) {

	//	console.log(model[key]);

		if(fieldsText && fieldsText.indexOf(key) >= 0){
			insertValueAsText(key, model[key], $modal);
		}

		if(fieldsInput && fieldsInput.indexOf(key) >= 0){
			insertValue(key, model[key], $modal);
		}

	}

}

ModalFormController.prototype.beforeShowTicketForContractor = function(data) {

	var $modal = this.$modal,
			$historyButtons = $modal.find('.js-ticket-contractor-btn-status');

	$historyButtons.each(function() {
		$(this).show();
	});

	if(data.history){

		if(data.history.status != 0){ // REQUEST
			$modal.find('.js-ticket-con-accept').hide() // HIDE ACCEPT BTN
			$modal.find('.js-ticket-con-decline').hide() // HIDE DECLINE BTN
		}

		if(data.history.status == 3){ // COMPLETED
			$modal.find('.js-ticket-con-complete').hide() // HIDE COMPLETE BTN
		}

	}

}

ModalFormController.prototype.clearModal = function() {
    this.cleanErrors();
    this.$form[0].reset();
}

ModalFormController.prototype.showModal = function() {
    this.$modal.modal('show');
}

ModalFormController.prototype.cleanErrors = function() {
    this.$modal.find('.has-error').removeClass('has-error');
    this.$modal.find('.text-danger').remove();
}

ModalFormController.prototype.closeModal = function() {
    this.$modal.modal('hide');
}

ModalFormController.prototype.getFieldsData = function() {
    return this.$form.serializeArray();
}

module.exports = ModalFormController;